import type { ReactNode } from 'react';

type SpaceVariations = 0 | 2 | 4 | 6 | 8 | 10 | 12 | 14 | 16 | 18 | 20 | 22;

type Spaces = `sp-${SpaceVariations}`;

export interface ContainerProps {
  children: ReactNode;
  fluid?: boolean;
  marginBottom?: Spaces;
  marginTop?: Spaces;
  size?: 'default' | 'full' | '1/2' | '1/3' | '2/3';
  horizontalAlign?: 'left' | 'center' | 'right';
  button?: boolean;
  dataTestid?: string;
}

export enum CONTAINER_CONST {
  TEST_ID = 'container',
}
